import { isEmpty } from "lodash";
import Pusher from "pusher-js";
import React from "react";

import config from "../config";
import NotificationService from "./notification.service";

const { PUSHER_KEY, PUSHER_CLUSTER } = config;

const pusher = new Pusher(PUSHER_KEY, {
  cluster: PUSHER_CLUSTER,
  forceTLS: true
});

const fileDownloader = unsub => async ({ url, filename }) => {
  NotificationService.addSuccess(
    <a href={url} download={filename} target="_blank" rel="noopener noreferrer" className="notification-link">
      Click to download the file
    </a>,
    { autoClose: false }
  );
  unsub();
};

const exportToNetsuite = unsub => async ({ errors, exported }) => {
  if (exported) {
    NotificationService.addSuccess(`${exported} invoices were exported to Netsuite`, { autoClose: true });
  }

  if (!isEmpty(errors)) {
    errors.forEach(error => {
      NotificationService.addError(`Invoice ${error} has failed to be exported to Netsuite.`, { autoClose: false });
    });
  }

  unsub();
};

class PusherServiceImpl {
  static handleCommonEvent(eventName, channelName) {
    const unsub = () => this.unsubscribe(eventName, channelName);
    switch (eventName) {
      case "file_download": {
        this.subscribe(eventName, channelName, fileDownloader(unsub));
        break;
      }
      case "export_to_netsuite": {
        this.subscribe(eventName, channelName, exportToNetsuite(unsub));
        break;
      }
      default: {
        return;
      }
    }
  }

  static subscribe(...args) {
    const fn = args.pop();
    const [eventName, channelName] = args;
    if (channelName) {
      this.subscribeChannel(channelName, eventName, fn);
    } else {
      this.subscribeEvent(eventName, fn);
    }
  }

  static unsubscribe(eventName, channelName) {
    if (!channelName) {
      pusher.unbind(eventName);
      return;
    }
    const channel = pusher.subscribe(channelName);
    channel.unbind(eventName);
  }

  static subscribeChannel(channelName, eventName, fn) {
    if (config.PUSHER_DISABLED === true) {
      return;
    }
    const channel = pusher.subscribe(channelName);
    channel.bind(eventName, fn);
  }

  static subscribeEvent(eventName, fn) {
    if (config.PUSHER_DISABLED === true) {
      return;
    }

    pusher.bind(eventName, fn);
  }
}

const PusherService = Object.freeze(PusherServiceImpl);
export default PusherService;
